export default __webpack_public_path__ + "static/media/security.fea3e6e7.svg";